import React from 'react';
import { BookOpen, Bookmark, ChevronDown, Download, HelpCircle, LogOut, Settings, UserRound } from 'lucide-react';
import { ASSETS } from '../../../lib/assets';
const items = [{
  label: 'Profile',
  icon: UserRound
}, {
  label: 'Billing',
  icon: BookOpen,
  expandable: true
}, {
  label: 'My Progress',
  icon: Bookmark
}, {
  label: 'Bookmarks',
  icon: Bookmark
}, {
  label: 'Downloaded Lesson',
  icon: Download
}, {
  label: 'Notifications',
  icon: HelpCircle
}, {
  label: 'Help',
  icon: HelpCircle,
  expandable: true
}, {
  label: 'Settings',
  icon: Settings
}];
export function ProfileDrawer({
  onClose,
  onSignOut
}: {
  onClose: () => void;
  onSignOut: () => void;
}) {
  return <div className="absolute inset-0 z-20 bg-black/40" role="presentation" onClick={onClose} data-id="element-291" data-mp="37hh4cg7tmyb6">
      <aside aria-label="Account navigation" onClick={event => event.stopPropagation()} className="flex h-full w-[84%] flex-col bg-[#bba5af]/95 px-4 pb-5 pt-4 text-white shadow-2xl" data-id="element-292" data-mp="2azku698qc9kv">
        <div className="flex items-center gap-3" data-id="element-293" data-mp="2ez3hfbo0wwqv"><img src={ASSETS.avatar} alt="Temp Testing avatar" className="h-9 w-9 rounded-full border border-white/60 object-cover" data-id="element-294" data-mp="2hqxyb0zvz52c" /><div data-id="element-295" data-mp="2csnz8fb1jkbg"><p className="text-xs font-bold" data-id="element-296" data-mp="2csnyue74piax">Temp Testing</p><p className="mt-0.5 text-[9px] text-white/75" data-id="element-297" data-mp="280mpp159c7p4">tivide5316@eduivps.com</p></div></div>
        <div className="mt-4 h-px bg-white/35" data-id="element-298" data-mp="27ya3gbsgvb69" />
        <nav className="mt-2 space-y-1" data-id="element-299" data-mp="230i6h3cysyv7">{items.map(({
          label,
          icon: Icon,
          expandable
        }) => <button key={label} className="flex w-full items-center gap-3 rounded px-1 py-1.5 text-left text-[10px] font-semibold hover:bg-white/10" data-id="element-300" data-mp="1y2p4ynmlwt19"><Icon className="h-3.5 w-3.5" data-id="element-301" data-mp="1tzaef311ku9k" /><span className="flex-1" data-id="element-302" data-mp="1p1qy7xksa7ez">{label}</span>{expandable && <ChevronDown className="h-3.5 w-3.5" data-id="element-303" data-mp="1p2jxyelbrwnm" />}</button>)}</nav>
        <button onClick={onSignOut} className="mt-auto h-9 rounded-md bg-white text-[10px] font-extrabold text-[#4d4353]" data-id="element-304" data-mp="1k37apsqjknki">SIGN OUT</button>
      </aside>
    </div>;
}